import React, { useContext } from 'react';
import { PermissionContext, RolePermissions } from '../../../../../../appContext';
import { pages } from '../../../common/constant';
import { PermisionDenied } from '../../../common/commonComponents';
import StudentSearchAndListing from './StudentSearchAndListing';

const CentralizedPaymentCollection = () => {

    const userPermissions = RolePermissions(useContext(PermissionContext), pages["centralizedPaymentCollection"]["id"]);

    return (
        userPermissions
            ? <StudentSearchAndListing />
            : <PermisionDenied />
    );
}

export default CentralizedPaymentCollection;